import { Link, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { getVisibleAdminMenuItems } from '../utils/adminPermissions';

function AdminSidebar({ onLogout, show = false, onNavigate, onClose }) {
  const location = useLocation();
  const userRole = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('user') || '{}')?.role || null;
    } catch (_e) {
      return null;
    }
  }, [location.pathname]);

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const menuItems = [
    {
      title: 'Dashboard',
      path: '/admin/dashboard',
      icon: 'bi-speedometer2'
    },
    {
      title: 'Users',
      path: '/admin/users',
      icon: 'bi-people'
    },
    {
      title: 'News & Posts',
      path: '/admin/news',
      icon: 'bi-newspaper'
    },
    {
      title: 'Blogs',
      path: '/admin/blogs',
      icon: 'bi-journal-text'
    },
    {
      title: 'Events',
      path: '/admin/events',
      icon: 'bi-calendar-event'
    },
    {
      title: 'Gallery',
      path: '/admin/gallery',
      icon: 'bi-images'
    },
    {
      title: 'Projects',
      path: '/admin/projects',
      icon: 'bi-folder-check'
    },
    {
      title: 'Diseases & Conditions',
      path: '/admin/diseases',
      icon: 'bi-heart-pulse'
    },
    {
      title: 'Tests & Procedures',
      path: '/admin/tests-procedures',
      icon: 'bi-clipboard2-check'
    },
    {
      title: 'Symptom browse text',
      path: '/admin/symptom-browse',
      icon: 'bi-card-text'
    },
    {
      title: 'Services',
      path: '/admin/services',
      icon: 'bi-hospital'
    },
    {
      title: 'Departments',
      path: '/admin/departments',
      icon: 'bi-building'
    },
    {
      title: 'Senior Management',
      path: '/admin/senior-management',
      icon: 'bi-people-fill'
    },
    {
      title: 'Donors & Partners',
      path: '/admin/donors-partners',
      icon: 'bi-handshake'
    },
    {
      title: 'Security Monitor',
      path: '/admin/security',
      icon: 'bi-shield-lock'
    },
    {
      title: 'Backups',
      path: '/admin/backups',
      icon: 'bi-cloud-arrow-up'
    },
    {
      title: 'Activity Logs',
      path: '/admin/activity-logs',
      icon: 'bi-clock-history'
    }
  ];
  const visibleMenuItems = getVisibleAdminMenuItems(userRole, menuItems);

  return (
    <div className={`admin-sidebar ${show ? 'show' : ''}`}>
      <div className="admin-sidebar-header">
        <div className="admin-sidebar-header-top">
          <h4 className="mb-0">TGH Admin</h4>
          <button
            type="button"
            className="admin-sidebar-close d-md-none"
            aria-label="Close admin menu"
            onClick={() => onClose?.()}
          >
            <i className="bi bi-x-lg" aria-hidden="true" />
          </button>
        </div>
        <small className="text-muted">Administration Panel</small>
      </div>

      <nav className="admin-sidebar-nav">
        {visibleMenuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`admin-sidebar-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => onNavigate?.()}
          >
            <i className={`bi ${item.icon} me-2`}></i>
            <span>{item.title}</span>
          </Link>
        ))}
      </nav>

      <div className="admin-sidebar-footer">
        <Link
          to="/admin/change-password"
          className={`admin-sidebar-item ${isActive('/admin/change-password') ? 'active' : ''}`}
          onClick={() => onNavigate?.()}
        >
          <i className="bi bi-key me-2"></i>
          <span>Change Password</span>
        </Link>
        <button
          className="admin-sidebar-item w-100 text-start"
          onClick={() => {
            onNavigate?.();
            onLogout();
          }}
        >
          <i className="bi bi-box-arrow-right me-2"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

export default AdminSidebar;
